// ---------- Video Component ----------

class VideoMedia extends BaseMedia {
  connectedCallback() {
    super.connectedCallback()
    this.setupThumbnailToggle()
    if (!this.autoplay) {
      this.addEventListener('click', this.play.bind(this), { once: true })
    }
  }

  setupThumbnailToggle() {
    const wrapper = this.closest('[data-video-thumbnail-wrapper]')
    const thumbnail = wrapper?.querySelector('[data-video-thumbnail]')

    if (!thumbnail || thumbnail.dataset.videoThumbnailBound === 'true') return

    const hideThumbnail = () => {
      thumbnail.hidden = true
      thumbnail.setAttribute('aria-hidden', 'true')
    }

    thumbnail.addEventListener('click', event => {
      event.preventDefault()
      hideThumbnail()
      this.play()
    })

    this.addEventListener('media:play', hideThumbnail)
    thumbnail.dataset.videoThumbnailBound = 'true'
  }

  getPlayerTarget() {
    this.setAttribute('loaded', '')

    if (this.host) {
      return this.setupThirdPartyVideoElement()
    } else {
      return this.setupNativeVideoElement()
    }
  }

  playerHandler(target, prop) {
    if (this.host === 'youtube') {
      prop === 'play' ? target.playVideo() : target.pauseVideo()
    } else {
      target[prop]()
    }
  }

  async setupThirdPartyVideoElement() {
    let player
    const template = this.querySelector('template')

    if (template) {
      template.replaceWith(template.content.firstElementChild.cloneNode(true))
    }

    if (this.host === 'youtube') {
      player = await this.setupYouTubePlayer()
    } else {
      player = await this.setupVimeoPlayer()
    }

    return player
  }

  setupNativeVideoElement() {
    const video = this.querySelector('video')

    video.addEventListener('play', () => this.setAttribute('playing', ''))
    video.addEventListener('pause', () => this.removeAttribute('playing'))

    return video
  }

  setupYouTubePlayer() {
    return new Promise(async resolve => {
      if (!window.YT?.Player) {
        await loadScript('https://www.youtube.com/iframe_api')
      }

      await onYouTubePromise

      const player = new YT.Player(this.querySelector('iframe'), {
        events: {
          onReady: () => resolve(player),
          onStateChange: event => {
            if (event.data === YT.PlayerState.PLAYING) {
              this.setAttribute('playing', '')
            } else {
              this.removeAttribute('playing')
            }
          }
        }
      })
    })
  }

  setupVimeoPlayer() {
    return new Promise(async resolve => {
      if (!window.Vimeo?.Player) {
        await loadScript('https://player.vimeo.com/api/player.js')
      }

      const player = new Vimeo.Player(this.querySelector('iframe'))

      player.on('play', () => this.setAttribute('playing', ''))
      player.on('pause', () => this.removeAttribute('playing'))
      player.on('ended', () => this.removeAttribute('playing'))

      resolve(player)
    })
  }

  get host() {
    return this.getAttribute('host')
  }
}
// ---------- Register Component ----------

customElements.define('video-media', VideoMedia)
